<template>
    <section class="pb-8" id="contact">
        <br><br>
        <v-row>
            <v-col cols="12">
                <h2 class="display-1 font-weight-thin text-center">Contacto</h2>
                <v-responsive class="mt-3 mb-6 mx-auto primary base-divider" max-width="42">
                <v-divider/>
                </v-responsive>
            </v-col>
        </v-row>
        <v-container fluid>


                  <v-row align="center" justify="center">
                    <v-col cols="10" >
                        <v-row justify="center">
                            <v-col cols="12" sm="5">
                                <h3 class="font-weight-light mt-3">
                                    Hazme llegar tu mensaje, me voy a contactar contigo muy rápido.
                                </h3>
                                <h3 class="font-weight-light mt-3">
                                    WhatsApp: 👉	
                                </h3>
                                <h3 class="font-weight-light">
                                    Email: antoniohernandezjosesantiago@gmail.com
                                </h3>
                            </v-col>
                            <v-col cols="12" sm="7">
                              <ValidationObserver ref="datos" v-slot="{ handleSubmit, invalid }">
                                <v-form @submit.prevent="handleSubmit(save)">
                                    <ValidationProvider v-slot="{ errors }" name="El campo nombre" rules="required">
                                        <v-text-field v-model="name" label="¿Cual es tu nombre?" :error-messages="errors" color="#13491E"></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider v-slot="{ errors }" name="El campo email" rules="required|email">
                                        <v-text-field v-model="email" label="¿Cual es tu E-mail?" :error-messages="errors" color="#13491E"></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider v-slot="{ errors }" name="El campo mensaje" rules="required">
                                        <v-textarea v-model="message" label="¿Cual es tu mensaje?" :error-messages="errors" color="#13491E"/>
                                    </ValidationProvider>


                                    <v-btn color="success" rounded block class="mt-3 white--text"  :disabled="invalid" type="submit" :loading="loading">
                                            Enviar
                                    </v-btn>

                                </v-form>
                              </ValidationObserver>
                            </v-col>
                        </v-row>
                    </v-col>

                   


                  </v-row>
                  


        </v-container>
    </section>
</template>

<script>
import emailjs from "@emailjs/browser";
import { required, email } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede estar vacío",
});
extend("email", {
  ...email,
  message: "Debes introducir un correo valido",
});
export default {
    name:'ContactComponent',
    components:{
    ValidationObserver,
    ValidationProvider,
    },
    data:()=>({
        valid:false,
        name:null,
        email:null,
        message:null,
        disable:true,
        loading:false
    }),
    methods:{
        async save(){
            this.loading=true
            const template={
                from_name:this.name,
                from_email:this.email,
                message:this.message
            }
            await emailjs.send('service_h299gl9',"template_dup5l1v", template,'2NhNRU-oUHyqfwWo1').then(e=>{
                this.$toast.success('Correo enviado ;)')
                console.log('Enviado')
            }).finally(()=>{
            this.name=null
            this.email=null
            this.message=null
            requestAnimationFrame(() => {
                this.$refs.datos.reset();
            });
            this.loading=false
            })
            
        }
    }
}
</script>

<style>

</style>